import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { components as Core, useTranslation } from '../../modules/core';
import { spacing, colors, fonts } from '../../styles';
import { actions as companiesActions, selectors as companiesSelectors } from '../../modules/companies';

/**
 * Incident Bar modal component.
 *
 * @param {object} props
 * @param {function} props.onClose
 */
export const IncidentBarModal = ({ onClose }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const adminSettings = useSelector(companiesSelectors.getAdminSettings);
    const isSaving = useSelector(companiesSelectors.isSavingIncidentSettings);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        dispatch(companiesActions.getAdminSettings());
    }, [dispatch]);

    useEffect(() => {
        if (adminSettings) {
            setIsActive(adminSettings.isIncidentActive || false);
        }
    }, [adminSettings]);

    const handleSave = () => {
        dispatch(companiesActions.updateIncidentSettings(isActive));
    };

    return (
        <Core.Modal
            isVisible={true}
            footer={null}
            onClose={onClose}
            modalWidth={400}
            title={t('incidentBar.title')}
        >
            <div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: spacing.s5 }}>
                    <span style={{ ...fonts.smMedium, color: colors.black }}>{t('incidentBar.activeLabel')}</span>
                    <Core.Toggle
                        checked={isActive}
                        onToggle={setIsActive}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Core.Button
                        label={t('incidentBar.save')}
                        isLoading={isSaving}
                        onPress={handleSave}
                    />
                </div>
            </div>
        </Core.Modal>
    );
};
